import { PartialType } from '../../../utils';
import { CreateVehicleAccidentPersonDto } from './create-vehicle-accident-person.dto';
export class UpdateVehicleAccidentPersonDto extends PartialType(CreateVehicleAccidentPersonDto) {
}
